import { render } from "./UPSTracker.vue?vue&type=template&id=6ab1f08a"
import script from "./UPSTracker.vue?vue&type=script&lang=js"
export * from "./UPSTracker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__